import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CdkTableModule } from '@angular/cdk/table';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AppHttpInterceptor } from './AppHttpInterceptor';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
//import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
//import { AngularEditorModule } from '@kolkov/angular-editor';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { SharedModule } from './shared/shared.module';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from '@app/app-routing.module';
import { NgIdleModule } from '@ng-idle/core'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { DataTablesModule } from 'angular-datatables';
import { HighchartsChartModule } from 'highcharts-angular';
import { MatTableExporterModule } from 'mat-table-exporter';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { TreeviewModule } from '@samotics/ngx-treeview';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AddassessorComponent } from './addassessor/addassessor.component';
import { AppComponent } from './app.component';
import { AssessorComponent } from './assessor/assessor.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FileviewerComponent } from './fileviewer/fileviewer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { PiechartComponent } from './piechart/piechart.component';
import { ReleasenoteComponent } from './releasenote/releasenote.component';
import { ReportComponent } from './report/report.component';
import { TicketComponent } from './ticket/ticket.component';
import { ChatWithUsersComponent } from './chat-with-users/chat-with-users.component';
import { TicketDetailComponent } from './ticket/ticket-detail/ticket-detail.component';
import { TutorialsComponent } from './tutorials/tutorials.component';
import { ToastrModule } from 'ngx-toastr';
import { SettingsComponent } from './settings/settings.component';
import { NotificationsettingsComponent } from './settings/notificationsettings/notificationsettings.component';
import { CompliancePagesComponent } from './settings/compliance-pages/compliance-pages.component';
import { SearchComponent } from './search/search.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { LinechartComponent } from './linechart/linechart.component';
import { NgApexchartsModule } from "ng-apexcharts";

import { ViewTicketComponent } from './view-ticket/view-ticket.component';
import { FormsModule } from '@angular/forms';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ReleasehistoryComponent } from './releasehistory/releasehistory.component';
import { QuestionUploadModalComponent } from './components/question-upload-modal/question-upload-modal.component';
import { AdmitCardComponent } from './components/admit-card/admit-card.component';
import { VerifyEmailComponentComponent } from './verify-email-component/verify-email-component.component';
import { NotificationsComponent } from './all-notifications/all-notifications.component';
import { DevConsoleComponent } from './dev-console/dev-console.component';
import { GenerateKeyComponent } from './generate-key/generate-key.component';
import { ApikeyLogsComponent } from './apikey-logs/apikey-logs.component';
import { AccessDocsComponent } from './access-docs/access-docs.component';
import { ApiClientComponent } from './api-client/api-client.component';
import { MarkdownModule } from 'ngx-markdown';
import { DataMappingComponent } from './data-mapping/data-mapping.component';
import { MatSliderModule } from '@angular/material/slider';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ApiIntegrationListComponent } from './api-integration-list/api-integration-list.component';


@NgModule({ schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    declarations: [
        AppComponent,
        NavbarComponent,
        FileviewerComponent,
        SidebarComponent,
        AdmitCardComponent,
    ],
    exports: [MatSlideToggleModule],
    bootstrap: [AppComponent], imports: [QuestionUploadModalComponent,
        TicketComponent,
        ChatWithUsersComponent,
        TicketDetailComponent,
        TutorialsComponent,
        VerifyEmailComponentComponent,
        ViewTicketComponent,
        DashboardComponent,
        ReportComponent,
        PiechartComponent,
        AssessorComponent,
        AddassessorComponent,
        ReleasenoteComponent,
        SettingsComponent,
        NotificationsettingsComponent,
        CompliancePagesComponent,
        SearchComponent,
        LinechartComponent,

        ReleasehistoryComponent,
        NotificationsComponent,
        DevConsoleComponent,
        GenerateKeyComponent,
        ApikeyLogsComponent,
        AccessDocsComponent,
        ApiClientComponent,
        DataMappingComponent,
        ApiIntegrationListComponent,
        FormsModule,
        MatSliderModule,
        MatSelectModule,
        MatFormFieldModule,
        InfiniteScrollModule,
        BrowserModule,
        AppRoutingModule,
        RouterModule,
        SharedModule,
        HighchartsChartModule,
        CdkTableModule,
        MatTableExporterModule,
        DataTablesModule,
        EditorModule,
        //CKEditorModule,
        //AngularEditorModule,
        BrowserAnimationsModule,
        NgApexchartsModule,
        MarkdownModule.forRoot({ loader: HttpClient }),
        NgxDocViewerModule,
        NgxExtendedPdfViewerModule,
        NgIdleModule.forRoot(),
        TreeviewModule.forRoot(),
        NgIdleKeepaliveModule.forRoot(),
        NgMultiSelectDropDownModule.forRoot(),
        BsDropdownModule.forRoot(),
        NgSelectModule,
        MatIconModule,
        MatButtonModule,
        MatStepperModule,
        ReactiveFormsModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-top-center',
            preventDuplicates: true,
        })], providers: [
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: MatDialogRef, useValue: {} },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AppHttpInterceptor,
            multi: true
        },
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
